import { BREAKPOINTS } from "layout";
import styled from "styled-components";

export const BackgroundVideo = styled.video`
  height: 880px;
  width: 100%;
  object-fit: cover;
  position: static;
  left: 0;
  opacity: 1;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    height: 640px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    height: 560px;
    min-height: 560px;
    object-position: center;
  }
`;
